import React from "react";
import {
  ContentLayout,
  Box,
  Link,
  SpaceBetween,
} from "@amzn/awsui-components-react/polaris";
import { ACCESS_REQUEST_URL } from "../../app/constants";
const Error403 = () => {
  return (
    <div className="centered">
      <ContentLayout>
        <Box variant="h1" textAlign="center">
          403 Error
        </Box>
        <Box variant="h2" textAlign="center">
          Forbidden
        </Box>
        <SpaceBetween direction="vertical" size="xs">
          <Box variant="p" textAlign="center">
            You do not have permissions to access this application.
            <Box variant="p" textAlign="center">
              If you believe you should have access to this page, please submit
              a ticket here:
            </Box>
            <Link href={ACCESS_REQUEST_URL} target="_blank">
              Access Request Ticket
            </Link>
          </Box>
        </SpaceBetween>
      </ContentLayout>
    </div>
  );
};
export default Error403;
